module.exports = __webpack_public_path__ + "assets/2f84f260f9dc4394b17117b70f9ff78b.mp4";